import React, { useCallback, useEffect, useState } from "react";
import { connect } from "react-redux";

import { useHistory, useParams } from "react-router-dom";

import { EntityType } from "@mapmycustomers/shared";

import PersonRecordPane from "@app/component/preview/PersonRecordPane";
import Path from "@app/enum/Path";
import { EntityViewState, getEntityView } from "@app/store/entityView";
import { hideEntityView } from "@app/store/entityView/actions";
import { EntityViewSource } from "@app/store/entityView/EntityViewPayload";
import { RootState } from "@app/store/rootReducer";

interface Props {
  entityView?: EntityViewState;
  onHideEntityView: typeof hideEntityView;
}

const PersonRecordPage: React.FC<Props> = ({ entityView, onHideEntityView }) => {
  const { pid } = useParams<{ pid: string | undefined }>();
  const history = useHistory();
  const [previousPeopleIds, setPreviousPeopleIds] = useState(pid ? [pid] : []);

  useEffect(() => {
    // Reset History Stack if person is opened from List view or global search
    setPreviousPeopleIds(pid ? [pid] : []);
  }, [pid]);

  useEffect(() => {
    if (
      entityView?.entityType !== EntityType.PERSON ||
      entityView?.source === EntityViewSource.GLOBAL_SEARCH
    ) {
      return;
    }
    setPreviousPeopleIds((ids) => {
      const newId = String(entityView.entityId);
      if (ids.length === 0 || ids[ids.length - 1] !== newId) {
        return [...ids, newId];
      }
      return ids;
    });
  }, [entityView, history]);

  const onHide = useCallback(() => {
    if (
      previousPeopleIds.length < 2 &&
      (!entityView?.entityId || entityView?.source === EntityViewSource.GLOBAL_SEARCH)
    ) {
      history.push(Path.PEOPLE);
    } else {
      setPreviousPeopleIds((ids) => ids.slice(0, -1));
    }

    if (entityView) {
      onHideEntityView();
    }
  }, [entityView, history, onHideEntityView, previousPeopleIds.length]);

  if (!previousPeopleIds.length) {
    return null;
  }

  const currentPersonId = parseInt(previousPeopleIds.at(-1)!, 10);
  return <PersonRecordPane onHide={onHide} personId={currentPersonId} />;
};

const mapStateToProps = (state: RootState) => ({
  entityView: getEntityView(state),
});

const mapDispatchToProps = {
  onHideEntityView: hideEntityView,
};

export default connect(mapStateToProps, mapDispatchToProps)(PersonRecordPage);
